// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dGsX","label":"styles_label__P-YWf"};